import { PayloadAction } from 'typesafe-actions';
import { PayrollContextActionTypes, PayrollState } from './types';

const PayrollReducer = (state: PayrollState, action: PayloadAction<PayrollContextActionTypes, any>): PayrollState => {
  switch (action.type) {
    case PayrollContextActionTypes.SetSelectedPayroll:
      return {
        ...state,
        selectedPayroll: action.payload,
      };

    case PayrollContextActionTypes.ResetSelectedPayroll:
      return {
        ...state,
        selectedPayroll: null,
      };
    default: {
      return state;
    }
  }
};

export { PayrollReducer };
